import API from "./api";

/**
 * Save approval memo to API
 * POST /api/Customer
 */
export const saveApprovalMemo = async (memoData) => {
  try {
    const payload = {
      name: memoData.customerName.trim(),
      contactNumber: memoData.mobile,
      date: memoData.invoiceDate,
      isActive: true,
    };

    console.log("📤 Sending to API:", payload);

    const response = await API.post("/Customer", payload);

    console.log("📥 API Response:", response.data);

    return {
      success: true,
      data: response.data,
    };

  } catch (error) {
    console.error("Save memo failed:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

/**
 * Test API connection
 */
export const testAPIConnection = async () => {
  try {
    const response = await API.options("/Customer");

    return {
      connected: true,
      status: response.status,
    };
  } catch (error) {
    return {
      connected: false,
      error: error.message,
    };
  }
};